<div class="swagger-fullpage">
  <div class="service-selector">
    <select (change)="selectService(+$event.target.value)">
      <option *ngFor="let service of serviceUrls; let i = index" [value]="i">
        {{service.name}}
      </option>
    </select>
  </div>
  <div id="swagger-ui"></div>
</div>